

















































import { Vue, Component, Prop } from "vue-property-decorator";

// Types
import { IDocsCategory } from "@/models/docs";

@Component
export default class DocsCategoryList extends Vue {
  // Props

  @Prop({ required: true })
  public categories!: IDocsCategory[];

  @Prop({ required: true })
  public isLoading!: boolean;
}
